import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './BookAnAppointment.scss';
import emailjs from 'emailjs-com';
import { Helmet } from "react-helmet";
import HomeAdvisor from '../../Images/HomeAdvisor.png'
import BBB from '../../Images/BBB.png'
import Angie from '../../Images/Angie.png'
import YELP from '../../Images/YELP.png'
import Google from '../../Images/Google.png'
import Trust from '../../Images/check.jpg'
import jQuery from 'jquery';
import validator from 'validator';

import Porch from '../../Images/Porch.png'
import Logo2 from '../../ImagesLogos/Logo2.png'
const BookAnAppointment = ({ CitiePhone, CitiesData, locationsMain }) => {
    const [Page1, setPage1] = useState(true);
    const [Page2, setPage2] = useState(false);
    const [Page3, setPage3] = useState(false);
    const [FormSubmiting, setFormSubmiting] = useState(false);
    const [response, setResponse] = useState({});
    const [CustInfoUpdate, setCustInfoUpdate] = useState(false);
    const url = new URL(window.location.href);
    const location = useLocation()
    const navigate = useNavigate()
    const queryParams = new URLSearchParams(location.search);
    const isFree = queryParams.get('free') === 'yes';

    const [CustInfo, setCustInfo] = useState({
        FirstName: '',
        LastName: '',
        PhoneNumber: '',
        Email: '',
        Service: isFree ? "Chimney Free Inspection" : url.pathname == '/airduct' ? "Air Duct Cleaning $99" : url.pathname == '/dryer' ? "Dryer Vent Cleaning $79" : url.pathname == '/chimney' ? "Chimney Inspection $69" : url.pathname == '/roofing' ? "Roofing Free Consultation" : url.pathname == '/hvac' ? "HVAC Free Consultation" : "Air Duct Cleaning $99",
        Date: new Date(new Date().getTime() + (24 * 60 * 60 * 1000)).toISOString().substr(0, 10),
        Time: '8:00AM-11:00AM',
        Address1: '',
        Address2: '',
        City: '',
        State: CitiesData && CitiesData.City ? CitiesData.Full.split(',')[1].replace(' ', '') : 'Alabama',
        Zipcode: '',
        Note: ''
    });

    async function getFinalIps() {
        try {
            // IPv6
            const responseIpv6 = await fetch('https://api64.ipify.org?format=json');
            const dataIpv6 = await responseIpv6.json();
            // IPv4
            const responseIpv4 = await fetch('https://api.ipify.org?format=json');
            const dataIpv4 = await responseIpv4.json();
            return `
IPv6: ${dataIpv6.ip}
IPv4: ${dataIpv4.ip}
`;
        } catch (error) {
            return 'Unable to fetch IP address.';
        }
    }
    getFinalIps()
    const [ipAddress, setIpAddress] = useState('');

    useEffect(() => {
        getFinalIps().then(ip => setIpAddress(ip));
    }, []);

    const FinalMessage = `
Taged: ${isFree ? "Yes | Free Estimate" : "No"}
SPG: ${url.searchParams.get('spg') == "g" ? "Google" : url.searchParams.get('spg') == "m" ? "Microsoft" : "Null"} | ${url.searchParams.get('ct') == "pmax" ? "pMax" : "Search"}
Company name: AttiAir 
Name: ${CustInfo.FirstName + ' ' + CustInfo.LastName}
Phone: ${CustInfo.PhoneNumber}
Address: ${CustInfo.Address1 + ', ' + CustInfo.City + ', ' + CustInfo.State + ', ' + CustInfo.Zipcode + ' ' + CustInfo.Address2}
Job type: ${url.pathname == '/airduct' ? "Air Duct" : url.pathname == '/dryer' ? "Air Duct" : url.pathname == '/chimney' ? "Chimney Sweep" : url.pathname == '/roofing' ? "Roofing" : url.pathname == '/hvac' ? "HVAC" : "null"} 
Type: ${CustInfo.Service}
Note: ${CustInfo.Note}
The Job date: ${CustInfo.Date.split("-")[1] + '/' + CustInfo.Date.split("-")[2] + '/' + CustInfo.Date.split("-")[0] + ' ' + CustInfo.Time.split('-')[0]}
The Job end date: ${CustInfo.Date.split("-")[1] + '/' + CustInfo.Date.split("-")[2] + '/' + CustInfo.Date.split("-")[0] + ' ' + CustInfo.Time.split('-')[1]}

${ipAddress}
      `

    const FinalMessageWhatsapp = `
Taged: ${isFree ? "Yes | Free Estimate" : "No"}
SPG: ${url.searchParams.get('spg') == "g" ? "Google" : url.searchParams.get('spg') == "m" ? "Microsoft" : "Null"} | ${url.searchParams.get('ct') == "pmax" ? "pMax" : "Search"}
Company name: AttiAir 
Name: ${CustInfo.FirstName + ' ' + CustInfo.LastName}
Phone: ${CustInfo.PhoneNumber}
Address: ${CustInfo.Address1 + ', ' + CustInfo.City + ', ' + CustInfo.State + ', ' + CustInfo.Zipcode + ' ' + CustInfo.Address2}
Job type: ${url.pathname == '/airduct' ? "Air Duct" : url.pathname == '/dryer' ? "Air Duct" : url.pathname == '/chimney' ? "Chimney Sweep" : url.pathname == '/roofing' ? "Roofing" : url.pathname == '/hvac' ? "HVAC" : "null"} 
Type: ${CustInfo.Service}
Note: ${CustInfo.Note}
The Job date: ${CustInfo.Date.split("-")[1] + '/' + CustInfo.Date.split("-")[2] + '/' + CustInfo.Date.split("-")[0] + ' ' + CustInfo.Time.split('-')[0]}
The Job end date: ${CustInfo.Date.split("-")[1] + '/' + CustInfo.Date.split("-")[2] + '/' + CustInfo.Date.split("-")[0] + ' ' + CustInfo.Time.split('-')[1]}
      `
    //   


    function sendEmail(e) {
        setFormSubmiting(true)
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

        emailjs.sendForm('service_fqud6um', 'template_n0o8yjw', e.target, 'QeqW-bXHRNjRmhZ6I')
            .then((result) => {
                setPage1(false)
                setPage2(false)
                setPage3(true)
                setFormSubmiting(false)
                {
                    CitiesData && CitiesData.City ?
                        navigate(`/thanks${location.search}name=${CustInfo.FirstName}&service=${CustInfo.Service}&message=Your appointment has been confirmed for ${CustInfo.Date.split("-")[1] + '/' + CustInfo.Date.split("-")[2] + '/' + CustInfo.Date.split("-")[0]} between ${CustInfo.Time} at ${CustInfo.Address1 + ', ' + CustInfo.City}`)
                        :
                        navigate(`/thanks?name=${CustInfo.FirstName}&service=${CustInfo.Service}&message=Your appointment has been confirmed for ${CustInfo.Date.split("-")[1] + '/' + CustInfo.Date.split("-")[2] + '/' + CustInfo.Date.split("-")[0]} between ${CustInfo.Time} at ${CustInfo.Address1 + ', ' + CustInfo.City}`)
                }
                sentMessage()
                sentJobToWhatsapp()
            }, (error) => {
                console.log(error.text);
            });
    }
    const sentMessage = async () => {
        const res = await fetch('https://api.callrail.com/v3/a/317-421-447/text-messages.json', {
            method: 'POST',
            headers: {
                'Authorization': 'Token token=dd02c8e45b65e07d612f8a21a51d9e1d',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'customer_phone_number': `${CustInfo.PhoneNumber.replace(/-/g, '')}`,
                'tracking_number': `${CitiesData && CitiesData.City ? CitiePhone.replace(/-/g, '') : '8665011614'}`,
                'content': `
Hi ${CustInfo.FirstName} 😊,
Thank you for booking your service with AttiAir! Your appointment has been confirmed for ${CustInfo.Date.split("-")[1] + '/' + CustInfo.Date.split("-")[2] + '/' + CustInfo.Date.split("-")[0]} Between ${CustInfo.Time} At ${CustInfo.Address1 + ', ' + CustInfo.City}

Our Technician will reach you out 30Min in advance at the appointment day.

Best regards 🤝
AttiAir .
                `,
                'company_id': '653209804'
            })
        })
        const data = await res.json()
    }
    const sentJobToWhatsapp = async () => {
        await fetch("https://api.ultramsg.com/instance120323/messages/chat", {
            method: "POST",
            body: new URLSearchParams({
                token: "ijne8s82zyrs5n7t",
                to: "120363419167541181@g.us",
                body: FinalMessageWhatsapp,
            }),
        }
        );
    }


    useEffect(() => {
        (async () => {
            try {
                const searchKeyword = `I need from you 32 words about the "${url.searchParams.get('kd')}" how we "AttiAir " can help our clients with that kind of service, give me that as json file: title 3 words (include in the title words from the keyword, remove null and AittAir good company from title)(if no keywords just do for how thiis company can  help) and body`
                const apiKey = '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'; // Replace with your actual API key
                const resChat = await fetch(`https://api.openai.com/v1/chat/completions`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiKey}`,
                    },
                    body: JSON.stringify({
                        'model': 'gpt-3.5-turbo',
                        'messages': [
                            {
                                'role': 'user',
                                'content': searchKeyword
                            }
                        ]
                    })
                })
                const dataChat = await resChat.json()

                setResponse(JSON.parse(dataChat.choices[0].message.content))
            } catch (error) {
                console.log(error);
            }
        })();
    }, []);


    return (
        <div className="BookAnAppointmentMainComponent" style={location.pathname == '/book' ? { "min-height": "100vh" } : null}>
            <Helmet>
                {/* <!-- TITLE -->  */}
                {/* <!-- Maximum of 65 characters --> */}
                <title>Schedule  Service Online | AttiAir | 866-501-1614</title>
                {/* <!-- Maximum 35 characters --> */}
                <meta name="title" property="title" content="Schedule  Service Online | AttiAir  | 866-501-1614" data-react-helmet="true" />
                <meta name="og:title" property="og:title" content="Schedule  Service Online | AttiAir  | 866-501-1614" data-react-helmet="true" />
                {/* <!-- META --> */}
                <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
                <meta name="og:type" property="og:type" content="article" data-react-helmet="true" />
                <meta name="og:image" property="og:image" content="article" data-react-helmet="true" />
                {/* Blog Tags */}
                <meta name="PageType" content="article" />
                <meta name="ContentType" content="article" />
                <meta name="Category" content="article" />
                <meta name="SubCategories" content="article" />
                <meta name="FunnelStage" content="upper" />
                <meta name="Objective" content="education, seo" />


                {/* <!-- Full link to the current webpage address -->  */}
                <meta name="og:url" property="og:url" content="https://www.attiair.com/book" data-react-helmet="true" />
                {/* <!-- Maximum of 155 characters  --> */}
                <meta name="description" content="Easily schedule your professional  service online with AttiAir . Book inspections, cleanings, and repairs at your convenience to keep your  safe and efficient." data-react-helmet="true" />
                {/* <!-- Maximum 65 characters --> */}
                <meta name="og:description" property="og:description" content="Easily schedule your professional  service online with AttiAir . Book inspections, cleanings, and repairs at your convenience to keep your  safe and efficient." data-react-helmet="true" />
                <meta name="og:site_name" property="og:site_name" content="Schedule  Service Online | AttiAir  | 866-501-1614" data-react-helmet="true" />
                <meta name="keywords" content=",  Inspection,  Inspection, Fireplace Inspection, Fireplace Cleaning,  Cleaning,  Maintenance, Fireplace Maintenance, Dryer Vent Cleaning,  Inspection, Fireplace Inspection, Fireplace Cleaning,  Cleaning,  Maintenance, Fireplace Maintenance, Dryer Vent Cleaning,  services,  service,  Inspection, Fireplace Inspection, Fireplace Cleaning,  Cleaning,  Maintenance, Fireplace Maintenance, Dryer Vent Cleaning,  Insulation,  Installation,  Liner Repair,  Pointing,  Rainp Installation,  Repair,  Crown Repair,  Restoration,  Flue Installation,  Flue Repair, ​ Construction,  Vent Installation,  Flashing, Flexible  Liner Installation,  Damper Repair, p Repair, Fireplace Insulation, Fireplace Installation, Fireplace Liner Repair, Fireplace Pointing, Fireplace Rainp Installation, Fireplace Repair, Fireplace Crown Repair, Fireplace Restoration, Fireplace Flue Installation, Fireplace Flue Repair, FIREPLACE Construction, Fireplace Vent Installation, Fireplace Flashing, Flexible fireplace Liner Installation, Fireplace Damper Repair, Fireplacep, Faq Page" data-react-helmet="true" />
            </Helmet>
            <div className="BookAnAppointmentMainComponentTop">
                <div className="BookAnAppointmentMainComponentTopLeft">
                    <h1>SCHEDULE SERVICE ONLINE</h1>
                    <h2>Servicing <b>{CitiesData && CitiesData.City ? CitiesData.Full.toUpperCase() : "Your Area"}</b> And Surrounding Areas - AttiAir </h2>
                    <h2>No extra charge for appointments on nights, weekends or holidays</h2>
                </div>
            </div>
            <div className='BookAnAppointmentMainComponentTopMain'>
                <div className="BookAnAppointmentMainComponentMaps">
                    <h4 style={Page1 || Page2 || Page3 ? {
                        "borderTop": "2px solid #DA291C"
                    } : null}>1. Information </h4>
                    <h4 style={Page2 || Page2 || Page3 ? {
                        "borderTop": "2px solid #DA291C"
                    } : null}>2. Address </h4>
                    <h4 style={Page3 ? {
                        "borderTop": "2px solid #DA291C"
                    } : null}>3. Note </h4>
                </div>
                {
                    Page1 ?
                        <div className="BookAnAppointmentMainComponentPage1">
                            <div className="BookAnAppointmentMainRightFullName">
                                <div className="BookAnAppointmentMainRightBox">
                                    <h4>Full Name <span>*</span></h4>
                                    <input
                                        defaultValue={CustInfo.FirstName}
                                        className='BookAnAppointmentMainRightBoxFirstName'
                                        onChange={(e) => {
                                            CustInfo.FirstName = e.target.value
                                            setCustInfoUpdate(e => !e)

                                        }} type="text" />
                                </div>
                                <div className="BookAnAppointmentMainRightBox">
                                    <h4>Phone Number <span>*</span></h4>
                                    <input
                                        defaultValue={CustInfo.PhoneNumber}
                                        className='BookAnAppointmentMainRightBoxPhone'
                                        onChange={(e) => {
                                            CustInfo.PhoneNumber = e.target.value
                                            setCustInfoUpdate(e => !e)

                                        }} type="tel" />
                                </div>
                                {/* <div className="BookAnAppointmentMainRightBox">
                                    <h4>Last Name <span>*</span></h4>
                                    <input
                                        defaultValue={CustInfo.LastName}
                                        className='BookAnAppointmentMainRightBoxLastName'
                                        onChange={(e) => {
                                            CustInfo.LastName = e.target.value
                                            setCustInfoUpdate(e => !e)
                                            
                                        }} type="text" />
                                </div> */}
                            </div>
                            <div className="BookAnAppointmentMainRightDateAndTime">
                                <div className="BookAnAppointmentMainRightBox">
                                    <h4>Appointment Date <span>*</span></h4>
                                    <input

                                        defaultValue={CustInfo.Date}
                                        className='BookAnAppointmentMainRightBoxDate'
                                        onChange={(e) => {
                                            CustInfo.Date = e.target.value
                                            setCustInfoUpdate(e => !e)

                                        }} type="date" />
                                </div>
                                <div className="BookAnAppointmentMainRightBox">
                                    <h4>Appointment Time <span>*</span></h4>
                                    <select
                                        defaultValue={CustInfo.Time}
                                        className='BookAnAppointmentMainRightBoxTime'
                                        onChange={(e) => {
                                            CustInfo.Time = e.target.value
                                            setCustInfoUpdate(e => !e)

                                        }} >
                                        <option value="8:00AM-11:00AM">8:00AM-11:00AM</option>
                                        <option value="11:00AM-01:00PM">11:00AM-01:00PM</option>
                                        <option value="01:00PM-03:00PM">01:00PM-04:00PM</option>
                                        <option value="04:00PM-07:00PM">04:00PM-07:00PM</option>
                                        <option value="Ask for a Representative">Ask for a Representative</option>
                                    </select>
                                </div>
                            </div>
                            <div className="BookAnAppointmentMainComponentButtons">
                                <button onClick={() => {

                                    if (!CustInfo.FirstName) { document.querySelector(".BookAnAppointmentMainRightBoxFirstName").style.border = "2px solid red"; } else { document.querySelector(".BookAnAppointmentMainRightBoxFirstName").style.border = "2px solid #6f6f6f61"; }
                                    // if (!CustInfo.LastName) { document.querySelector(".BookAnAppointmentMainRightBoxLastName").style.border = "2px solid red"; } else { document.querySelector(".BookAnAppointmentMainRightBoxLastName").style.border = "2px solid #6f6f6f61"; }
                                    if (validator.isMobilePhone(CustInfo.PhoneNumber) && CustInfo.PhoneNumber.length >= 10) { document.querySelector(".BookAnAppointmentMainRightBoxPhone").style.border = "2px solid #6f6f6f61"; } else { document.querySelector(".BookAnAppointmentMainRightBoxPhone").style.border = "2px solid red"; }
                                    if (!CustInfo.Date) { document.querySelector(".BookAnAppointmentMainRightBoxDate").style.border = "2px solid red"; } else { document.querySelector(".BookAnAppointmentMainRightBoxDate").style.border = "2px solid #6f6f6f61"; }
                                    if (!CustInfo.Time) { document.querySelector(".BookAnAppointmentMainRightBoxTime").style.border = "2px solid red"; } else { document.querySelector(".BookAnAppointmentMainRightBoxTime").style.border = "2px solid #6f6f6f61"; }

                                    if (
                                        CustInfo.FirstName &&
                                        // CustInfo.LastName &&
                                        validator.isMobilePhone(CustInfo.PhoneNumber) && CustInfo.PhoneNumber.length >= 10 &&
                                        CustInfo.Service &&
                                        CustInfo.Date &&
                                        CustInfo.Time
                                    ) {
                                        setPage1(false)
                                        setPage2(true)
                                        CustInfo.State = CitiesData && CitiesData.City ? CitiesData.Full.split(',')[1].replace(' ', '') : 'Alabama'
                                    } else {
                                        console.log('no')
                                    }
                                }}>NEXT</button>
                            </div>
                        </div>
                        : null
                }
                {
                    Page2 ?
                        <div className="BookAnAppointmentMainComponentPage2">
                            <div className="BookAnAppointmentMainRightAddress1">
                                <div className="BookAnAppointmentMainRightBox">
                                    <h4>Address Line 1 <span>*</span></h4>
                                    <input
                                        className='BookAnAppointmentMainRightBoxAddress1'
                                        defaultValue={CustInfo.Address1}
                                        onChange={(e) => {
                                            CustInfo.Address1 = e.target.value
                                            setCustInfoUpdate(e => !e)

                                        }} type="text" />
                                </div>
                            </div>
                            <div className="BookAnAppointmentMainRightAddress2">
                                <div className="BookAnAppointmentMainRightBox">
                                    <h4>Address Line 2 (Optional)</h4>
                                    <input
                                        defaultValue={CustInfo.Address2}
                                        onChange={(e) => {
                                            CustInfo.Address2 = e.target.value
                                            setCustInfoUpdate(e => !e)

                                        }} type="text" />
                                </div>
                            </div>
                            <div className="BookAnAppointmentMainRightAddress3">
                                <div className="BookAnAppointmentMainRightBox">
                                    <h4>City <span>*</span></h4>
                                    <input
                                        className='BookAnAppointmentMainRightBoxCity'
                                        defaultValue={CustInfo.City}
                                        onChange={(e) => {
                                            CustInfo.City = e.target.value
                                            setCustInfoUpdate(e => !e)

                                        }} type="text" />
                                </div>
                                <div className="BookAnAppointmentMainRightBox">
                                    <h4>State <span>*</span></h4>
                                    <select
                                        defaultValue={CitiesData && CitiesData.City ? CitiesData.Full.split(',')[1].replace(' ', '') : 'Alabama'}
                                        onChange={(e) => {
                                            CustInfo.State = e.target.value
                                            setCustInfoUpdate(e => !e)
                                        }}>
                                        {/* <option value="" disabled selected>Select your State</option> */}
                                        <option value="Alabama">Alabama</option>
                                        <option value="Alaska">Alaska</option>
                                        <option value="Arizona">Arizona</option>
                                        <option value="Arkansas">Arkansas</option>
                                        <option value="California">California</option>
                                        <option value="Colorado">Colorado</option>
                                        <option value="Connecticut">Connecticut</option>
                                        <option value="Delaware">Delaware</option>
                                        <option value="District Of Columbia">District Of Columbia</option>
                                        <option value="Florida">Florida</option>
                                        <option value="Georgia">Georgia</option>
                                        <option value="Hawaii">Hawaii</option>
                                        <option value="Idaho">Idaho</option>
                                        <option value="Illinois">Illinois</option>
                                        <option value="Indiana">Indiana</option>
                                        <option value="Iowa">Iowa</option>
                                        <option value="Kansas">Kansas</option>
                                        <option value="Kentucky">Kentucky</option>
                                        <option value="Louisiana">Louisiana</option>
                                        <option value="Maine">Maine</option>
                                        <option value="Maryland">Maryland</option>
                                        <option value="Massachusetts">Massachusetts</option>
                                        <option value="Michigan">Michigan</option>
                                        <option value="Minnesota">Minnesota</option>
                                        <option value="Mississippi">Mississippi</option>
                                        <option value="Missouri">Missouri</option>
                                        <option value="Montana">Montana</option>
                                        <option value="Nebraska">Nebraska</option>
                                        <option value="Nevada">Nevada</option>
                                        <option value="New Hampshire">New Hampshire</option>
                                        <option value="New Jersey">New Jersey</option>
                                        <option value="New Mexico">New Mexico</option>
                                        <option value="New York">New York</option>
                                        <option value="Northrolina">Northrolina</option>
                                        <option value="North Dakota">North Dakota</option>
                                        <option value="Ohio">Ohio</option>
                                        <option value="Oklahoma">Oklahoma</option>
                                        <option value="Oregon">Oregon</option>
                                        <option value="Pennsylvania">Pennsylvania</option>
                                        <option value="Rhode Island">Rhode Island</option>
                                        <option value="Southrolina">Southrolina</option>
                                        <option value="South Dakota">South Dakota</option>
                                        <option value="Tennessee">Tennessee</option>
                                        <option value="Texas">Texas</option>
                                        <option value="Utah">Utah</option>
                                        <option value="Vermont">Vermont</option>
                                        <option value="Virginia">Virginia</option>
                                        <option value="Washington">Washington</option>
                                        <option value="West Virginia">West Virginia</option>
                                        <option value="Wisconsin">Wisconsin</option>
                                        <option value="Wyoming">Wyoming</option>
                                    </select>
                                </div>
                                <div className="BookAnAppointmentMainRightBox">
                                    <h4>Zipcode <span>*</span></h4>
                                    <input
                                        className='BookAnAppointmentMainRightBoxZipcode'
                                        defaultValue={CustInfo.Zipcode}
                                        onChange={(e) => {
                                            CustInfo.Zipcode = e.target.value
                                            setCustInfoUpdate(e => !e)

                                        }} type="tel" />
                                </div>
                            </div>
                            <div className="BookAnAppointmentMainComponentButtons">
                                <button onClick={() => {

                                    setPage1(true)
                                    setPage2(false)
                                    setPage3(false)
                                }}>PREVIOUS</button>
                                <button onClick={() => {

                                    if (!CustInfo.Address1) { document.querySelector(".BookAnAppointmentMainRightBoxAddress1").style.border = "2px solid red"; } else { document.querySelector(".BookAnAppointmentMainRightBoxAddress1").style.border = "2px solid #6f6f6f61"; }
                                    if (!CustInfo.City) { document.querySelector(".BookAnAppointmentMainRightBoxCity").style.border = "2px solid red"; } else { document.querySelector(".BookAnAppointmentMainRightBoxCity").style.border = "2px solid #6f6f6f61"; }
                                    if (!CustInfo.Zipcode) { document.querySelector(".BookAnAppointmentMainRightBoxZipcode").style.border = "2px solid red"; } else { document.querySelector(".BookAnAppointmentMainRightBoxZipcode").style.border = "2px solid #6f6f6f61"; }

                                    if (
                                        CustInfo.Address1 &&
                                        CustInfo.City &&
                                        CustInfo.Zipcode
                                    ) {
                                        setPage1(false)
                                        setPage2(false)
                                        setPage3(true)
                                    } else {
                                        console.log('no')
                                    }

                                }}>NEXT</button>
                            </div>
                        </div>
                        : null
                }
                {
                    Page3 ?
                        <div className="BookAnAppointmentMainComponentPage3">

                            <div className="BookAnAppointmentMainRightNote">
                                <div className="BookAnAppointmentMainRightBox">
                                    <h4>Note (Optional)</h4>
                                    <textarea
                                        defaultValue={CustInfo.Note}
                                        onChange={(e) => {
                                            CustInfo.Note = e.target.value
                                            setCustInfoUpdate(e => !e)

                                        }} type="text" />
                                </div>
                            </div>
                            <div className="BookAnAppointmentMainRightServices">
                                <div className="BookAnAppointmentMainRightBox">
                                    <h4>Service Needed <span>*</span> <h5>Click to select different service</h5></h4>
                                    <div className="BookAnAppointmentMainRightBoxBox">

                                        <select
                                            defaultValue={CustInfo.Service}
                                            onChange={(e) => {
                                                CustInfo.Service = e.target.value
                                                setCustInfoUpdate(e => !e)
                                                console.log(FinalMessage);
                                            }} name="" id="">
                                            {

                                                isFree ?
                                                    <>
                                                        <option value="Chimney Free Inspection">Chimney Free Inspection</option>
                                                        <option value="Air Duct Free Inspection">Air Duct Free Inspection</option>
                                                        <option value="Dryer Vent Free Inspection">Dryer Vent Free Inspection</option>
                                                        <option value="Roofing Free Inspection">Roofing Free Inspection</option>
                                                        <option value="HVAC Free Inspection">HVAC Free Inspection</option>
                                                    </>
                                                    :
                                                    url.pathname == '/airduct' ?
                                                        <>
                                                            <option value="Air Duct Cleaning $99">Air Duct Cleaning $99</option>
                                                            <option value="Dryer Vent Cleaning $79">Dryer Vent Cleaning $79</option>
                                                            <option value="Air Duct & Dryer Vent Cleaning $149">Air Duct & Dryer Vent Cleaning $149</option>
                                                            <option value="Free On-Site Consultation">Free On-Site Consultation</option>
                                                        </>
                                                        :
                                                        url.pathname == '/dryer' ?
                                                            <>

                                                                <option value="Dryer Vent Cleaning $79">Dryer Vent Cleaning $79</option>
                                                                <option value="Air Duct Cleaning $99">Air Duct Cleaning $99</option>
                                                                <option value="Air Duct & Dryer Vent Cleaning $149">Air Duct & Dryer Vent Cleaning $149</option>
                                                                <option value="Free On-Site Consultation">Free On-Site Consultation</option>
                                                            </>
                                                            :
                                                            url.pathname == '/chimney' ?
                                                                <>
                                                                    <option value="Chimney Inspection $69">Chimney Inspection $69</option>
                                                                    <option value="Dryer Vent Cleaning $79">Dryer Vent Cleaning $79</option>
                                                                    <option value="Air Duct Cleaning $99">Air Duct Cleaning $99</option>
                                                                    <option value="Air Duct & Dryer Vent Cleaning $149">Air Duct & Dryer Vent Cleaning $149</option>
                                                                    <option value="Free On-Site Consultation">Free On-Site Consultation</option>
                                                                </>
                                                                :
                                                                url.pathname == '/roofing' ?
                                                                    <>
                                                                        <option value="Roofing - Free Consultation">Roofing - Free Consultation</option>
                                                                    </>
                                                                    :
                                                                    url.pathname == '/hvac' ?
                                                                        <>
                                                                            <option value="HVAC - Free Consultation">HVAC - Free Consultation</option>
                                                                        </>
                                                                        :
                                                                        url.pathname == '/' || url.pathname == '/book' ?
                                                                            <>
                                                                                <option value="Air Duct Cleaning $99">Air Duct Cleaning $99</option>
                                                                                <option value="Dryer Vent Cleaning $79">Dryer Vent Cleaning $79</option>
                                                                                <option value="Chimney Inspection $69">Chimney Inspection $69</option>
                                                                                <option value="Air Duct & Dryer Vent Cleaning $149">Air Duct & Dryer Vent Cleaning $149</option>
                                                                                <option value="HVAC - Free Consultation">HVAC - Free Consultation</option>
                                                                                <option value="Roofing - Free Consultation">Roofing - Free Consultation</option>
                                                                                <option value="Free On-Site Consultation">Free On-Site Consultation</option>
                                                                            </>

                                                                            : null
                                            }
                                        </select>

                                        <img src={require(`../../Images/downArrow.jpg`)} />

                                    </div>

                                    <h3>Payment required only if/when service is done.</h3>
                                    <h3>Our technician will likely complete any additional service during the same visit, saving you time and hassle!</h3>
                                </div>
                            </div>
                            <div className="BookAnAppointmentMainComponentButtons">
                                <button onClick={() => {
                                    setPage1(false)
                                    setPage2(true)
                                    setPage3(false)
                                }}>PREVIOUS</button>

                                {
                                    !FormSubmiting ?
                                        <form className="contact-form" onSubmit={sendEmail}>
                                            <input type="hidden" name="from_name" defaultValue={FinalMessage} />
                                            {/* Cust Info */}
                                            <input type="hidden" name="Date" defaultValue={CustInfo.Date.split("-")[1] + '/' + CustInfo.Date.split("-")[2] + '/' + CustInfo.Date.split("-")[0] + ' ' + CustInfo.Time} />
                                            <input type="hidden" name="Service_Type" defaultValue={CustInfo.Service} />
                                            <input type="hidden" name="Send_To" defaultValue={CustInfo.Email} />
                                            <input type="hidden" name="Cust_Name" defaultValue={CustInfo.FirstName} />
                                            <input type="hidden" name="Company_From" defaultValue={`AttiAir `} />
                                            <input type="hidden" name="Company" defaultValue={`AttiAir | ${url.pathname == '/airduct' ? "Air Duct" : url.pathname == '/dryer' ? "Dryer" : url.pathname == '/chimney' ? "Chimney" : url.pathname == '/roofing' ? "Roofing" : url.pathname == '/hvac' ? "HVAC" : "HomePage"} | ${CustInfo.City + ', ' + CustInfo.State}`} />
                                            <input type="submit" value="SEND" />
                                        </form>
                                        :
                                        null
                                }

                                {
                                    FormSubmiting ?
                                        <button class="buttonload">
                                            <i class="fa fa-refresh fa-spin"></i>Loading
                                        </button>
                                        :
                                        null
                                }
                            </div>
                        </div>
                        : null
                }
                {location.pathname == "/local" ? null : <div className="BookAnAppointmentMainComponentEmergery">

                    <div className="BookAnAppointmentMainComponentRates">
                        <div className="BookAnAppointmentMainComponentRatesImages">
                            <img src={YELP} alt="AttiAir  Cleaning Yelp Review" />
                            <img src={Angie} alt="AttiAir  Cleaning Angie Review" />
                            <img src={HomeAdvisor} alt="AttiAir  Cleaning HomeAdvisor Review" />
                            <img src={BBB} alt="AttiAir  Cleaning BBB Review" />
                            <img src={Google} alt="AttiAir  Cleaning Google Review" />
                            <img src={Porch} alt="AttiAir  Cleaning Porch Review" />
                            <img src={Trust} alt="AttiAir  Cleaning Trust Review" />
                        </div>
                        <h1>Customer Testimonials</h1>
                        <h2>⭐⭐⭐⭐⭐</h2>
                        <h3>I’ve had a great experience with AttiAir. The team is professional, reliable, and truly cares about doing the job right. They’re always on time, easy to work with, and make the whole process simple and stress-free. It’s clear they prioritize quality and customer satisfaction, and I couldn’t be happier with the results.</h3>
                    </div>
                    <div className="BookAnAppointmentMainComponentEmergeryBox">
                        <a href={`tel:${CitiePhone}`}>For emergency service Call: {CitiePhone}</a>
                    </div>
                </div>
                }
            </div>
            {/* MainBanner2Top2 */}
            {location.pathname == "/book" ?
                <div className="MainBanner2Top2" id="ourservices">
                    <div className="MainBanner2TopBox">
                        <div className="MainBanner2TopBoxBack">
                            {/*  */}
                        </div>
                        <div className="MainBanner2TopBoxMain">
                            <div className="MainBanner2TopBoxMenu">
                                <a className="MainBanner2TopBoxBox">
                                    <img src={require(`../../Images/aircleaning.png`)} alt="Safe and Healthy Home" />
                                    <h3>Healthier Home</h3>
                                    <h4>Better Air Quality</h4>
                                    <h2>We help create a cleaner, healthier living environment by reducing harmful buildup and improving the air you breathe.</h2>
                                </a>
                                <a className="MainBanner2TopBoxBox">
                                    <img src={require(`../../Images/airdryer.png`)} alt="Home Safety" />
                                    <h3>Peace of Mind</h3>
                                    <h4>Enhanced Safety</h4>
                                    <h2>We protect your home by reducing the risk of fire hazards and ensuring everything runs safely and smoothly.</h2>
                                </a>
                                <a className="MainBanner2TopBoxBox">
                                    <img src={require(`../../Images/airinspection.png`)} alt="Cost Savings" />
                                    <h3>Save Money</h3>
                                    <h4>Prevent Costly Repairs</h4>
                                    <h2>We help you avoid expensive emergency repairs by keeping your system in top shape with proactive care.</h2>
                                </a>
                                <a className="MainBanner2TopBoxBox">
                                    <img src={require(`../../Images/airrepair.png`)} alt="Comfort and Efficiency" />
                                    <h3>Comfort Year-Round</h3>
                                    <h4>Maximum Efficiency</h4>
                                    <h2>We optimize your system’s performance so your home stays comfortable while using less energy.</h2>
                                </a>

                            </div>
                            <div className="MainBanner2TopBoxMainChat">
                                <img src={require(`../../ImagesLogos/Logo2.png`)} />
                                <div className="MainBanner2TopBoxMainChatText">
                                    <h4>{response.title}</h4>
                                    <h3>{response.body}</h3>
                                    <h5>Call us at <a href={`tel:${CitiePhone}`}>{CitiePhone}</a> or fill out the <a href={`/book${location.search}`}>online form</a> to schedule your visit.</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :
                null}

        </div >
    );
}

export default BookAnAppointment;
